import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import MainHeader from "../../../../common/MainHeader";
import { USAPhoneNumberFormate } from "../../../../../utilities/Utilities";

export default function ContactInfo(props) {
  const [profileContactInfo, setProfileContactInfo] = useState(null);
  const [showAllInfo, setShowAllInfo] = useState(false);

  useEffect(() => {
    const { contactInfo } = props;

    if (contactInfo) {
      setProfileContactInfo(contactInfo);
    }

    if (props?.showAllInfo) {
      setShowAllInfo(props?.showAllInfo);
    }
  }, [props]);

  return (
    <Col>
      <MainHeader title="Contact Info" />
      {!props?.isDispatcherPhone && (
        <div>
          <div
            style={{
              color: "#959595",
              marginTop: "5px",
              textTransform: "capitalize",
            }}
          >
            <UserOutlined /> {profileContactInfo?.relationShip}
          </div>
          <div style={{ color: "#959595", marginTop: "5px" }}>
            <PhoneOutlined /> {USAPhoneNumberFormate(profileContactInfo?.phone)}
          </div>
          <div
            style={{
              color: "#959595",
              marginTop: "5px",
              textTransform: "lowercase",
            }}
          >
            <MailOutlined /> {profileContactInfo?.email}
          </div>
        </div>
      )}

      {showAllInfo && (
        <div>
          <div
            style={{
              color: "#959595",
              textTransform: "capitalize",
            }}
          >
            {profileContactInfo?.addaddress !== undefined &&
            profileContactInfo?.addaddress !== null &&
            profileContactInfo?.addaddress !== "" ? (
              <span>
                <EnvironmentOutlined /> {profileContactInfo?.addaddress}
              </span>
            ) : (
              ""
            )}
          </div>

          <div
            style={{
              color: "#959595",
              textTransform: "capitalize",
            }}
          >
            {profileContactInfo?.address !== undefined &&
            profileContactInfo?.address !== null &&
            profileContactInfo?.address !== "" ? (
              <span>
                <EnvironmentOutlined /> {profileContactInfo?.address}
              </span>
            ) : (
              ""
            )}
          </div>

          <Row justify={"start"}>
            <Col>
              <div
                style={{
                  color: "#959595",
                  textTransform: "capitalize",
                }}
              >
                {profileContactInfo?.city !== undefined &&
                profileContactInfo?.city !== null &&
                profileContactInfo?.city !== "" ? (
                  <span>{profileContactInfo?.city},</span>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Col>
              <div
                style={{
                  color: "#959595",
                  textTransform: "capitalize",
                }}
              >
                {profileContactInfo?.state !== undefined &&
                profileContactInfo?.state !== null &&
                profileContactInfo?.state !== "" ? (
                  <span>{profileContactInfo?.state},</span>
                ) : (
                  ""
                )}
              </div>
            </Col>
            <Col>
              <div
                style={{
                  color: "#959595",
                  textTransform: "capitalize",
                }}
              >
                {profileContactInfo?.code || ""}
              </div>
            </Col>
          </Row>

          <Row gutter={[8, 8]} justify={"start"} style={{ marginTop: "5px" }}>
            <Col span={24}>
              <div>
                <span style={{ color: "#767676" }}>
                  <UserOutlined /> Guardian
                </span>
              </div>
              <div>
                <span style={{ color: "#000" }}>
                  {profileContactInfo?.guardianName || "N/A"}
                </span>
              </div>
            </Col>

            <Col span={24}>
              <div>
                <span style={{ color: "#767676" }}>
                  <PhoneOutlined /> Day Time
                </span>
              </div>
              <div>
                <span style={{ color: "#000" }}>
                  {USAPhoneNumberFormate(profileContactInfo?.dayTimePhoneNo) ||
                    "N/A"}
                </span>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </Col>
  );
}
